import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/client/components/ui/card';
import { Button } from '@/client/components/ui/button';
import { Key, Copy, Check } from 'lucide-react';
import type { ClientApiKeys } from '@shared/types';

interface ApiKeysCardProps {
  api: ClientApiKeys | null;
}

export function ApiKeysCard({ api }: ApiKeysCardProps) {
  const [copied, setCopied] = useState(false);

  if (!api) {
    return null;
  }

  const handleCopy = async () => {
    await navigator.clipboard.writeText(api.APIkey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-medium flex items-center gap-2">
          <Key className="h-4 w-4" />
          API Access
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-2">
          <div className="min-w-0 flex-1">
            <div className="text-xs text-muted-foreground">API Key</div>
            <div className="font-mono text-sm truncate">{api.APIkey}</div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 flex-shrink-0"
            onClick={handleCopy}
          >
            {copied ? (
              <Check className="h-4 w-4 text-green-600" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
